import styled, { css } from 'styled-components';
import { Tooltip } from './../../../tooltip/tooltip';
import { getColor, getColorShade, getSizeBy } from '../../../../../src/styled/utils';
import { Body2Styles } from '../../../typography';
const pinnedCSS = css `
  position: sticky;
  background-color: ${({ theme }) => theme.colors.surface};
`;
export const StyledCell = styled.td `
  ${Body2Styles};
  padding: ${getSizeBy(1.5)} ${getSizeBy(2)};
  color: ${getColorShade('onSurface', 'highEmphasis')};
  text-align: start;
  vertical-align: middle;
  ${({ $isPinned }) => $isPinned && pinnedCSS}

  &.pinned::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.surface};
    content: '';
  }

  &.money div {
    justify-content: flex-end;
  }

  &.money-with-padding div {
    justify-content: flex-end;
    padding-right: 40%;
  }

  &:first-child {
    padding-left: ${getSizeBy(4)};
  }

  &:last-child {
    padding-right: ${getSizeBy(4)};
  }
`;
export const StyledTooltip = styled(Tooltip) `
  min-width: ${getSizeBy(35)};
  ${({ $external }) => $external}
`;
export const TooltipContent = styled.div `
  ${Body2Styles};
  display: flex;
  flex-direction: column;
  color: ${getColor('onPrimary', 'highEmphasis')};
`;
